import { createStore } from 'vuex'

export default createStore({
  state: {
    hasRoutes:false
  },
  getters: {
  },
  mutations: {
    changeHasRoutes(state,value){
      state.hasRoutes = value
    }
  },
  actions: {
  },
  modules: {
  }
})
